import { Nullable } from '@/scripts/models/utility-types';
import { AuthTrackerPayload, AuthTrackerPayloadRequest } from '@/scripts/models/tracker/authTrackerPayload';
import { AuthTrackerIntent } from '@/scripts/models/tracker/AuthTrackerIntent';

export const makeAuthTrackerPayload = (payload?: Nullable<AuthTrackerPayload>): AuthTrackerPayloadRequest => {
  const p = payload ?? {};

  const filledPayload = {
    client: p.client ?? `web@${window.ENVS.APPLICATION_VERSION}`,
    intent: p.intent ?? AuthTrackerIntent.Unknown,
    section: p.section,
    // eslint-disable-next-line @typescript-eslint/camelcase
    screen_url: p.screenUrl,
    // eslint-disable-next-line @typescript-eslint/camelcase
    resource_uri: p.resourceUri,
    // eslint-disable-next-line @typescript-eslint/camelcase
    screen_name: p.screenName,
    query: p.query,
  };

  return Object.fromEntries(
    Object
      .entries(filledPayload)
      // Remove null / undefined value
      .filter(([, value]) => value != null),
  );
};
